const accountingPT = {
    "view": {
        "table": {
            "title": "Lista de Contabilidade",
            "column": {
                "release": "Lançamento",
                "period": "Período",
                "royalties": "Royalties",
                "costs": "Custos",
                "net_revenue": "Receita Líquida",
                "status": "Status",
                "accounting_report": "Relatório Contábil",
                "details": "Detalhes"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "button": {
                "statusCreating": "Criando",
                "statusGenerating": "Gerando",
                "statusGenerated": "Gerado",
                "statusNotGenerated": "Não Gerado",
                "open": "Abrir",
                "downloadPDF": "Baixar PDF",
                "generatingPDF": "Gerando PDF",
                "exportCsv": "Exportar CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para utilizar este recurso.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>retome</1> sua assinatura para utilizar este recurso.",
            "noAccess": "Você não tem acesso a este módulo, por favor entre em contato com a equipe de suporte para mais informações."
        }
    },
    "add": {
        "form": {
            "label": {
                "filters": "Filtros",
                "monthRange": "Intervalo de Meses",
                "release": "Lançamento"
            },
            "options": {
                "allReleases": "Todos os Lançamentos"
            },
            "placeholder": {
                "startingMonth": "Mês de Início",
                "endingMonth": "Mês de Término"
            },
            "button": {
                "generate": "Gerar Relatório Contábil",
                "reset": "Redefinir Filtros"
            },
            "table": {
                "title": "Ganhos disponíveis para contabilidade",
                "columns": {
                    "month": "Mês",
                    "year": "Ano",
                    "revenue": "Receita",
                    "status": "Status"
                },
                "label": {
                    "status_open": "Aberto",
                    "status_accounted": "Contabilizado",
                    "month_january": "Janeiro",
                    "month_february": "Fevereiro",
                    "month_march": "Março",
                    "month_april": "Abril",
                    "month_may": "Maio",
                    "month_june": "Junho",
                    "month_july": "Julho",
                    "month_august": "Agosto",
                    "month_september": "Setembro",
                    "month_october": "Outubro",
                    "month_november": "Novembro",
                    "month_december": "Dezembro"
                }
            }
        },
        "modal": {
            "header": "Adicionar Contabilidade",
            "body": "Tem certeza de que deseja adicionar nova contabilidade para o Lançamento: {{release}}, PERÍODO: {{startingMonth}} ATÉ {{endingMonth}} ?"
        },
        "message": {
            "success": "Contabilidade foi criada!",
            "errorSomethingWentWrong": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "errorNoEarningsAvailable": "Nenhum ganho disponível para contabilidade.",
            "errorNoReleaseSelected": "Por favor, selecione um lançamento específico para contabilidade."
        }
    },
    "breakdown": {
        "view": {
            "table": {
                "title": "Detalhamento Contábil",
                "column": {
                    "revenueShareHolder": "Acionista",
                    "revenue": "Royalty Líquido do Acionista",
                    "reportPdf": "Baixar PDF",
                    "action": "Ação",
                    "emailSent": "Email Enviado"
                },
                "label": {
                    "downloadPDF": "Baixar PDF",
                    "generatingPDF": "Gerando PDF"
                },
                "button": {
                    "exportCsv": "Exportar CSV"
                },
                "modal": {
                    "confirm": {
                        "header": "Enviar Relatório para Acionista",
                        "body": "Tem certeza de que deseja enviar o relatório para o acionista?",
                        "message": {
                            "success": "Relatório enviado com sucesso!"
                        },
                        "button": {
                            "cancel": "Cancelar",
                            "confirm": "Confirmar"
                        }
                    }
                },
                "message": {
                    "success": "Relatório contábil foi enviado!",
                    "errorSomethingWentWrong": "Algo deu errado! Por favor, atualize a página e tente novamente!",
                    "errorEmailNotPresent": "Email do acionista não presente!",
                    "errorNoReportAvailable": "Nenhum relatório disponível para este lançamento."
                }
            }
        }
    }
};

export default accountingPT;